
import React, { useEffect, useState } from 'react';
import {
    Alert, Autocomplete, Backdrop, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle, FormControlLabel, Grid, IconButton, InputAdornment,
    InputBase, Paper, Snackbar, TextField,
    Tooltip,
    Typography
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import TextsmsIcon from '@mui/icons-material/Textsms';
import SendIcon from '@mui/icons-material/Send';
import { getClientesAgora, getOpcionesCrearTareas, getProyectos, getUsuarios, getUsuariosCliente, postTarea } from '../../../services/apis';
import { useParams } from 'react-router-dom';
import AutocompleteList from '../../../utils/componentes-utiles/AutocompleteList';
import { AlertError } from '../../../utils/componentes-utiles/AlertError';
import { CheckBox } from '@mui/icons-material';
import { SelectorRoles } from './SelectorRoles';
import TimeCounter from '../../../utils/componentes-utiles/TimeCounter';
import { filtrarProyectosVisibles, ordenarOpcionesPorLabel, textoMayusculas } from '../../../utils/utils';

export const FormCrearTarea = ({
    open,
    setOpen,
    tareaInfo,
    handleEvent,
    backgroundCard,
    textColor,
    opclientes,
    cargarTareas,
    opTrabajadores,
    opcionesTipoTareas,
    setOpcionesTipoTareas,
    idProyectoPreselec,
    idClientePreselec,
    trabajadoresPreselec = [],
    opProyectosPreCargados = []
}) => {
    const handleClose = () => {
        setOpen(false);
    };

    const param = useParams();
    const normalizarTrabajadoresPreselec = () => (
        Array.isArray(trabajadoresPreselec)
            ? trabajadoresPreselec.filter((trabajador) => Number(trabajador.value) !== 0)
            : []
    );
    const trabajadoresPreselecNormalizados = normalizarTrabajadoresPreselec();
    const trabajadoresPreselecKey = trabajadoresPreselecNormalizados.map((trabajador) => trabajador.value).join('-') || 'sin-asignado';
    const rolesTicketsWebSA = [985, 986, 901, 802];
    const parseRolesPermitidos = (rolesPermitidos) => {
        if (Array.isArray(rolesPermitidos)) {
            return rolesPermitidos.map(Number).filter((rol) => !Number.isNaN(rol));
        }

        if (!rolesPermitidos) {
            return [];
        }

        try {
            const rolesParseados = JSON.parse(rolesPermitidos);
            if (Array.isArray(rolesParseados)) {
                return rolesParseados.map(Number).filter((rol) => !Number.isNaN(rol));
            }
        } catch (error) {
            return String(rolesPermitidos)
                .replace(/^\s*\[|\]\s*$/g, '')
                .split(',')
                .map((rol) => Number(String(rol).trim()))
                .filter((rol) => !Number.isNaN(rol));
        }

        return [];
    };
    const [usuarioSelec, setUsuarioSelec] = useState({ label: "Seleccione un Usuario", value: "0" });
    const [opUsuarios, setOpUsuarios] = useState([]);
    const [enviando, setEnviando] = useState(false);
    const [errorAlert, setErrorAlert] = useState(false);
    const [clienteSelec, setClienteSelec] = useState({ label: "Seleccione un Cliente", value: "0" });
    const [trabajadorSelec, setTrabajadorSelec] = useState(trabajadoresPreselecNormalizados);
    const [archivos, setArchivos] = useState([]);
    const [opProyectos, setOpProyectos] = useState(opProyectosPreCargados);
    const [proyectos, setProyectos] = useState([]);
    const [proyectoSelec, setProyectoSelec] = useState({ label: 'Seleccione un Proyecto', value: "0" });
    const [oculto, setOculto] = useState(false);
    const [tipoTarea, setTipoTarea] = useState({ label: 'Sin Tipo', value: "0" });
    const [opciones, setOpciones] = useState([])
    const [todosUsuarios, setTodosUsuarios] = useState([]);
    const [roles, setRoles] = useState([])
    const [rolSelect, setRolSelect] = useState([]);
    const [tiempoEstimado, setTiempoEstimado] = useState(0);

    const [opClientesAgora, setOpClientesAgora] = useState({ label: 'Seleccione un Proyecto', value: "0" });
    const [nombreClienteAgora, setNombreClienteAgora] = useState({ label: '', value: "0" });
    const [tarea, setTarea] = useState({
        'fecha': new Date(),
        'asunto': '',
        'descripcion': '',
        'localizacion': '',
        'id_cliente': null,
        'id_usuario': null,
        'minutos': '',
        'minutos_estimados': '',
        'id_proyecto': param.id,
        'oculto': true
    });

    const opcionesOcultas = {
        SelectorRoles: <SelectorRoles roles={roles} setRoles={setRoles} rolSelect={rolSelect} setRolSelect={setRolSelect}></SelectorRoles>,
    };

    const handleChange = (event) => {
        const tareaNueva = { ...tarea, [event.target.name]: event.target.value };
        setTarea(tareaNueva);
        setErrorAlert(false)
    };


    const handleArchivoChange = (event) => {
        setArchivos((prevArchivos) => [
            ...prevArchivos,
            ...Array.from(event.target.files) // Agregar los nuevos archivos
        ]);
    };



    const isNullInObject = (obj) => {
        // Lista de campos que se deben omitir en la validación
        const camposExcepcion = ['localizacion', 'minutos', 'minutos_estimados', 'id_cliente', 'id_proyecto', 'trabajadores', 'id_usuario', 'oculto', 'correo', 'tipo_tarea', 'nombre_cliente_agora'];

        return Object.keys(obj).every(key => {
            if (camposExcepcion.includes(key)) {
                return true;
            }
            return obj[key] !== null && obj[key] !== '' && obj[key] != 0;
        });
    };

    const crearTarea = async () => {

        const nuevaTareaTmp = { ...tarea };
        nuevaTareaTmp.id_cliente = clienteSelec.value;
        nuevaTareaTmp.id_usuario = usuarioSelec.value;


        // Corrección aquí:
        const usuarioEncontrado = todosUsuarios.find(usu => usu.id === usuarioSelec.value);
        nuevaTareaTmp.correo = usuarioSelec.value != 0 && usuarioEncontrado ? usuarioEncontrado.mail : null;


        nuevaTareaTmp.id_proyecto = proyectoSelec.value;
        nuevaTareaTmp.trabajadores = trabajadorSelec;
        nuevaTareaTmp.tipo_tarea = tipoTarea.value;
        nuevaTareaTmp.oculto = oculto;
        nuevaTareaTmp.minutos_estimados = tiempoEstimado > 0 ? tiempoEstimado : '';
        nuevaTareaTmp.nombre_cliente_agora = nombreClienteAgora.label == '' ? null : nombreClienteAgora.label;
        nuevaTareaTmp.rolesPermitidos = rolSelect;

        const tareaComprobada = isNullInObject(nuevaTareaTmp);

        if (!tareaComprobada) {
            console.error("Hay campos vacíos o no válidos en la tarea");
            setErrorAlert(true);
            return; // Detener la ejecución si hay campos no válidos
        }
        setEnviando(true);

        try {
            const response = await postTarea(nuevaTareaTmp, archivos);
            if (response.success === true) {
                handleClose();

                cargarTareas();
                setTarea(
                    {
                        'fecha': new Date(),
                        'asunto': '',
                        'descripcion': '',
                        'localizacion': '',
                        'id_cliente': null,
                        'id_usuario': null,
                        'minutos': '',
                        'minutos_estimados': '',
                        'id_proyecto': param.id
                    });
                setArchivos(null)
                setTrabajadorSelec([]);
                setTiempoEstimado(0);
                handleClose();
                setEnviando(false);
                setearProyecto(opProyectos, idProyectoPreselec);
                setearCliente();
            }
        } catch (error) {
            console.error("Error al cargar tareas", error);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        crearTarea();
    };


    const eliminarArchivo = (index) => {
        const nuevosArchivos = archivos.filter((_, i) => i !== index);
        setArchivos(nuevosArchivos);
    };

    const cargarUsuarios = async (id) => {

        try {
            const response = await getUsuariosCliente(id);
            const tmp = [...response.data];
            setTodosUsuarios(response.data);
            const newTmp = ordenarOpcionesPorLabel(tmp.map((item, index) => ({
                label: textoMayusculas(item.nombre),
                value: item.id
            })))

            setOpUsuarios(newTmp);

        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }
    const cargarProyectos = async () => {
        try {
            if (opProyectosPreCargados.length > 0) {
                const proyectosVisibles = filtrarProyectosVisibles(opProyectosPreCargados);
                if (proyectosVisibles.length > 0) {
                    setOpProyectos(proyectosVisibles);
                    setearProyecto(proyectosVisibles, idProyectoPreselec);
                    return;
                }
            }

            const response = await getProyectos();
            setProyectos(response.data);
            iterarProyectos(response.data);

        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }
    const cargarClientesAgpra = async () => {
        try {
            const response = await getClientesAgora();
            iterarClientesAgora(response.data);

        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }
    if (param.id === '104') {

    }

    const cargarOpciones = async () => {
        try {
            const response = await getOpcionesCrearTareas();
            console.log(response);

            if (response.success) {
                setOpciones(response.data)
                setRoles(response.roles)
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }

    const setearProyecto = (data, idProyecto) => {
        const proyecto = data.find(p => Number(p.value) === Number(idProyecto));
        setProyectoSelec(proyecto || { label: 'Seleccione un Proyecto', value: "0" });
    };

    const iterarProyectos = (data) => {
        try {
            const tmp = filtrarProyectosVisibles(data);
            const newTmp = ordenarOpcionesPorLabel(tmp.map((item) => ({
                label: textoMayusculas(item.nombre),
                value: item.id,
                roles_permitidos: item.roles_permitidos,
                oculto: item.oculto
            })));

            setOpProyectos(newTmp);

            // Seleccionar proyecto si se encuentra el ID
            setearProyecto(newTmp, idProyectoPreselec);
        } catch (error) {
            console.error("Error al cargar proyectos:", error);
        }
    };

    const iterarClientesAgora = (data) => {
        try {
            const tmp = [...data];
            const newTmp = ordenarOpcionesPorLabel(tmp.map((item) => ({
                label: textoMayusculas(item.nombre),
                value: item.id
            })));

            setOpClientesAgora(newTmp);

            // Seleccionar proyecto si se encuentra el ID
        } catch (error) {
            console.error("Error al cargar proyectos:", error);
        }
    };


    useEffect(() => {
        if (clienteSelec.value != "0") {
            cargarUsuarios(clienteSelec.value);
            setUsuarioSelec({ label: "Seleccione un Usuario", value: "0" });

        } else {
            setUsuarioSelec({ label: "Seleccione un Usuario", value: "0" });

        }
    }, [clienteSelec]);

    const setearCliente = () => {
        if (idClientePreselec && opclientes.length > 0) {
            const cliente = opclientes.find(c => Number(c.value) === Number(idClientePreselec));
            if (cliente) {
                setClienteSelec(cliente);
            }
        }
    }
    useEffect(() => {
        setearCliente();
    }, [idClientePreselec, opclientes]);

    useEffect(() => {
        cargarProyectos(); // Esto carga los proyectos
        cargarOpciones();
        cargarClientesAgpra();
    }, []);

    useEffect(() => {
        if (open) {
            setTrabajadorSelec(trabajadoresPreselecNormalizados);
        }
    }, [open, trabajadoresPreselec]);

    useEffect(() => {
        if (idProyectoPreselec !== null && idProyectoPreselec !== undefined && opProyectos.length > 0) {
            setearProyecto(opProyectos, idProyectoPreselec);
        }
    }, [idProyectoPreselec, opProyectos]);

    useEffect(() => {
        if (proyectoSelec?.value === undefined || proyectoSelec?.value === null || proyectoSelec?.value === '') {
            setRolSelect([]);
            return;
        }

        if (Number(proyectoSelec.value) === 0) {
            setRolSelect(rolesTicketsWebSA);
            return;
        }

        const proyectoSeleccionado = opProyectos.find(
            (proyecto) => Number(proyecto.value) === Number(proyectoSelec.value)
        );

        setRolSelect(parseRolesPermitidos(proyectoSeleccionado?.roles_permitidos));
    }, [proyectoSelec?.value, opProyectos]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            aria-describedby="form-dialog-description"
            maxWidth={'sm'}
            fullWidth={true}
        >
            <Backdrop
                sx={{ zIndex: 1000 }}
                open={enviando}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <DialogContent style={{
                backgroundColor: `#${backgroundCard}`,
                color: textColor
            }}
            >
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    xs={12}
                    gap={1}
                    sx={{ mb: 3 }}
                >
                    <Typography variant="h6">
                        Nueva Solicitud de Ayuda
                    </Typography>

                    <CancelIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
                </Grid>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2} direction="column">
                        <Grid item>
                            <Autocomplete
                                fullWidth
                                className={opclientes ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                options={opclientes}
                                value={clienteSelec}
                                onChange={(event, newValue) => setClienteSelec(newValue ? newValue : '')}
                                renderInput={(params) => <TextField {...params} label="Obligatorio*" />}
                            />
                        </Grid>
                        <Grid item>
                            <Autocomplete
                                fullWidth
                                className={opUsuarios ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                options={opUsuarios}
                                value={usuarioSelec}
                                onChange={(event, newValue) => setUsuarioSelec(newValue)}
                                renderInput={(params) => <TextField {...params} label="Obligatorio*" />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                fullWidth
                                className={opProyectos ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                name="Proyecto"
                                options={opProyectos}
                                value={proyectoSelec}
                                onChange={(event, newValue) => {
                                    setProyectoSelec(newValue);
                                }}
                                renderInput={(params) => <TextField {...params} label="Proyecto*" />}
                            />
                        </Grid>
                        <Grid item>
                            {/* <Typography variant="subtitle1" sx={{ mb: -2 }}>
                                Asignar Empleado:
                            </Typography> */}
                            <AutocompleteList
                                key={`${open ? 'open' : 'closed'}-${trabajadoresPreselecKey}`}
                                array={opTrabajadores}
                                setArray={setTrabajadorSelec}
                                arrayPre={trabajadoresPreselecNormalizados}
                                label={'Asignar Empleado:'}
                            />
                        </Grid>
                        <Grid item>
                            <Autocomplete
                                fullWidth
                                className={opcionesTipoTareas ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                options={opcionesTipoTareas}
                                value={tipoTarea}
                                onChange={(event, newValue) => setTipoTarea(newValue ? newValue : '')}
                                renderInput={(params) => <TextField {...params} label="Tipo Tarea*" />}
                            />
                        </Grid>
                        {param.id === '104' && (
                            <Grid item>
                                <Autocomplete
                                    fullWidth
                                    className={opClientesAgora ? "inputDateInput" : 'inputDateInput-empty'}
                                    disablePortal
                                    id="combo-box-demo"
                                    options={opClientesAgora}
                                    value={nombreClienteAgora}
                                    onChange={(event, newValue) => setNombreClienteAgora(newValue ? newValue : '')}
                                    renderInput={(params) => <TextField {...params} label="Cliente Agora" />}
                                />
                            </Grid>
                        )}
                        <Grid item>
                            <TextField
                                label="Asunto"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="asunto"
                                value={tarea.asunto}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                label="Descripción"
                                variant="outlined"
                                multiline
                                rows={4}
                                fullWidth
                                name="descripcion"
                                value={tarea.descripcion}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                        <Grid item>
                            <TimeCounter
                                time={tiempoEstimado}
                                setTime={setTiempoEstimado}
                                tiempo={0}
                                label="Horas estimadas"
                            />
                        </Grid>
                    </Grid>

                    {opciones[0] && (
                        <Grid item xs={12}>
                            {opcionesOcultas[opciones[0].nombre]}
                        </Grid>
                    )}

                    <Grid item>
                        <Button variant="contained" component="label" sx={{ mt: 2 }}>
                            Subir Archivos
                            <input
                                type="file"
                                hidden
                                multiple
                                onChange={handleArchivoChange}
                            />
                        </Button>

                        {archivos && archivos.length > 0 && (
                            <div style={{ marginTop: '10px' }}>
                                {archivos && archivos.length > 0 && (
                                    <div style={{ marginTop: '10px' }}>
                                        {archivos.map((archivo, index) => (
                                            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                                <Button
                                                    onClick={() => eliminarArchivo(index)}
                                                    style={{ marginLeft: '10px', cursor: 'pointer' }}
                                                >
                                                    X
                                                </Button>
                                                <span>{archivo.name}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </Grid>


                </form>
            </DialogContent>

            <DialogActions style={{
                backgroundColor: `#${backgroundCard}`,
                color: textColor
            }}>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained">
                    Crear Tarea
                </Button>
            </DialogActions>
            {errorAlert && (
                <AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Falta rellenar algún campo obligatorio"} />
            )}
        </Dialog>
    );
};
